import { render, staticRenderFns } from "./IrrigationPlanAdd.vue?vue&type=template&id=19157d88&scoped=true&"
import script from "./IrrigationPlanAdd.vue?vue&type=script&lang=ts&"
export * from "./IrrigationPlanAdd.vue?vue&type=script&lang=ts&"
import style0 from "./IrrigationPlanAdd.vue?vue&type=style&index=0&id=19157d88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19157d88",
  null
  
)

export default component.exports